import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-z-edit-social-links',
  templateUrl: './z-edit-social-links.component.html',
  styleUrls: ['./z-edit-social-links.component.scss']
})
export class ZEditSocialLinksComponent implements OnInit {

    productId: string | null = null;
    product: any = {
  platform: '',
  link: '',
  };
  platforms: string[] = [
  'facebook',
  'instagram',
  'twitter',
  'tiktok',
  'linkedin',
  'youtube',
  'snapchat',
  'whatsapp',
  'telegram'
];

   public arrCoupons: any[] = [];


constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService
  ) {}
    ngOnInit(): void {
    // get product id from route
    this.productId = this.route.snapshot.paramMap.get('id');

    if (this.productId) {
      this.loadProduct(this.productId);
    }


                     this.apiService.users().subscribe({ 
      next:(response:any)=> { 
        this.arrCoupons = response.data.data || [] ;
        console.log('response is' , this.arrCoupons)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })

  }

  // Fetch product details (create an API if not exists)
loadProduct(id: string): void {
  this.apiService.getSocialLinks(id).subscribe({
    next: (res: any) => {
      const data = res.data;
      this.product.platform = data.platform;
      this.product.link = data.link;

    },
    error: (err) => {
      console.error('Failed to load product:', err);  
      this.toastr.error('Failed to load notification details');
    }
  });
}


    onFileSelected(event: any): void {
    if (event.target.files.length > 0) {
      this.product.image = event.target.files[0];
    }
  }
  // Update product

  
    updateProduct(): void {
    if (!this.productId) return;

    this.apiService.editSocialLinks(this.productId, this.product).subscribe({
      next: (res) => {
        this.toastr.success('  updated successfully');
        this.router.navigate(['/z-social-links']); // redirect after save
      },
      error: (err) => {
        console.error('Update failed:', err);
        this.toastr.error('Failed to update  ');
      }
    });
  }


}